/**
 * Mesh Gradient - Stripe風WebGLメッシュグラデーション
 * @see https://whatamesh.vercel.app/
 * @see https://gist.github.com/jordienr/64bcf75f8b08641f205bd6a1a0d4ce1d
 */

export { StripeGradient } from './stripe-gradient';
export type { StripeGradientConfig } from './stripe-gradient';
export { useGradient } from './use-gradient';
export type { UseGradientOptions, UseGradientReturn } from './use-gradient';
